import React, { Suspense, lazy } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HeroSection from '../components/Home/HeroSection';
import SEOHead from '../components/SEO/SEOHead';

const HomeBelowFold = lazy(() => import('./HomeBelowFold'));

const buildHomeSchema = (lng) => ({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'FinMaple',
      url: 'https://www.finmaple.com',
      logo: 'https://www.finmaple.com/logo.png',
      description: 'Plataforma de educación financiera para latinos en Canadá',
      availableLanguage: ['es', 'en', 'fr'],
    },
    {
      '@type': 'WebSite',
      name: 'FinMaple',
      url: 'https://www.finmaple.com',
      inLanguage: lng,
      availableLanguage: ['es', 'en', 'fr'],
    },
  ],
});

const HomePage = () => {
  const { i18n } = useTranslation();
  const homeSchema = buildHomeSchema(i18n.language);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <SEOHead
        seoKey="home"
        title={null}
        description="Compara tarjetas de crédito, cuentas bancarias, hipotecas y más - todo explicado en español para latinos en Canadá."
        canonical="/"
        schema={homeSchema}
        routeKey="home"
      />
      {/* Hero: no lazy — visible immediately, drives LCP */}
      <HeroSection />
      {/* Below-fold: lazy-loaded to reduce initial JS parse/execute */}
      <Suspense fallback={null}>
        <HomeBelowFold />
      </Suspense>
    </Box>
  );
};

export default HomePage;
